<div class="custom-dialog-container">
	<h2 class="dialog-header-title">
		{{ data.title }}
	</h2>

	<mat-divider></mat-divider>

	<p class="dialog-message">{{ data.message }}</p>

	@if (data.htmlContent) {
		<div class="inner-html" [innerHtml]="data.htmlContent"></div>
	}

	<div class="button-row">
		<button
			mat-button
			class="secondary-button"
			[mat-dialog-close]="{ isCancelButtonClicked: true, isConfirmButtonClicked: false }"
		>
			{{ data.cancelButtonText }}
		</button>
		<button
			mat-button
			class="primary-button"
			[mat-dialog-close]="{ isCancelButtonClicked: false, isConfirmButtonClicked: true }"
			cdkFocusInitial
		>
			{{ data.confirmButtonText }}
		</button>
	</div>
</div>
